/**
 * Values carried by `rowData.tickets.value`, identifying the printer's ticket
 * type. Used to gate which tabs/fields the printer-setting modal exposes
 * (customer side vs kitchen side).
 */
export const PRINTER_TICKET_TYPE = {
    /** Customer receipt printer. */
    CUSTOMER: "01",
    /** Kitchen production printer. */
    PRODUCTION: "02",
    /** Sticker printer (kitchen side). */
    STICKER: "03",
    /** Voucher printer (kitchen side). */
    VOUCHER: "04",
} as const;

export type PrinterTicketTypeValue =
    typeof PRINTER_TICKET_TYPE[keyof typeof PRINTER_TICKET_TYPE];

/**
 * Shared API path (appended to REACT_APP_API_V2_URL) used by every printer
 * setting config to fetch the available modes of sale. Centralised here so the
 * endpoint has a single source of truth across the POS/KDS/Kiosk/Peripherals
 * configs.
 */
export const PRINTER_MODE_OF_SALE_PATH = "/settings/general/mode_of_sale";
